export const API = process.env.REACT_APP_BACKEND_URL + '/api/reports/sales-analytics';
export const authHeaders = () => ({ Authorization: 'Bearer ' + localStorage.getItem('token') });

export const toParams = (filters, search) => {
  const p = {};
  Object.entries(filters).forEach(([k, v]) => {
    if (k.endsWith('_preset')) return;
    if (Array.isArray(v) ? v.length : v !== undefined && v !== null && v !== '') p[k] = Array.isArray(v) ? v.join('|') : v;
  });
  if (search && search.trim()) p.search = search.trim();
  return p;
};
